import { Slot } from 'client-generator/generated-clients/plants';

export interface WorkflowCallbackData {
  warningTitle?: string;
  warningMessage?: string;
  _adjacentSlotVm?: Slot;
  isConfirmation?: boolean; //choose if show 'yes/no' or 'ok'
  _isUnlinkFlow?: boolean;
  _isSingleLoadFlow?: boolean;
  _isMostrineFlow?: boolean;

  isWarningRequested?: boolean; //open a popup
  isPresetWarningRequested?: boolean; //open another popup
}
export interface WorkflowCallbackFunction {
  (
    data: WorkflowCallbackData,
    doYesCallback?: Function,
    doNoCallback?: Function,
    doAlertCallback?: Function
  ): void;
}

export enum SlotRuleServiceType {
  AUTOMATION_ACTUATOR,
  AUTOMATION_COMMAND,
  THERMO_THERMO,
  THERMO_PROBE,
  THERMO_HEATING_ACTUATORS,
  THERMO_COOLING_ACTUATORS,
  THERMO_HEATING_PUMPS,
  THERMO_COOLING_PUMPS,
  THERMO_SHARED_ACTUATORS,
  THERMO_SHARED_PUMPS,
  COMMANDS_AND_GROUPS,
}
